import {
  SectionedHorizontalLinedTable,
  SwitchAppButton,
} from "../../components";
import { SectionedHeader } from "../../components/SectionedHorizontalLinedTable/SectionedHeader";
import { LeftRightSection } from "../../components/SectionedHorizontalLinedTable/LeftRightSection";
import { ActivationRequiredWarning } from "../../components";
import { IHookForm, IInvoiceSettings } from "../../interfaces-and-types";
import { SubmitButton } from "../../hook-form";
import { Link } from "react-router-dom";

export const View = ({
  goBack,
  isDirty,
  handleSubmit,
  errors,
  register,
}: IHookForm<IInvoiceSettings> & {
  goBack: () => void;
  isDirty: boolean;
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <ActivationRequiredWarning
        title="Please you need to activate your profile"
        subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
        urlTarget="/onboarding"
      />

      <SectionedHorizontalLinedTable>
        <SectionedHeader
          hasBorder={true}
          mainHead="Configure invoice template"
          subHead=""
        />

        <LeftRightSection
          hasBorder={true}
          leftText="Branding"
          rightText={
            <>
              Change your invoice emails, reciepts, and payment page appearance
              in &nbsp;
              <Link to={`/settings/branding`} className="switchapp-link">
                Branding Settings.
              </Link>
            </>
          }
        />

        <LeftRightSection
          hasBorder={true}
          leftText="Business information"
          rightText={
            <>
              Change the contact information that shows up on your invoices and
              receipts in &nbsp;
              <Link
                to={`/settings/business-details`}
                className="switchapp-link"
              >
                Business settings.
              </Link>
            </>
          }
        />

        <LeftRightSection
          hasBorder={true}
          leftText="Default memo"
          rightText={
            <div className="flex-container textarea-container col justify-content--center align-item--start">
              <div>
                <textarea
                  maxLength={500}
                  {...register("payment_default_memo")}
                ></textarea>
              </div>
              <div className="flex-containet justify-content--start">
                <span className="text-secondary">
                  This will appear in the invoice email, PDF, and payment page.
                </span>
              </div>
            </div>
          }
        />

        {/* <LeftRightSection
          hasBorder={true}
          leftText="Default memo"
          rightText={
            <div className="flex-container textarea-container col justify-content--center align-item--start">
              <div>
                <textarea
                  maxLength={500}
                  {...register("receipt_and_invoice_default_memo")}
                ></textarea>
              </div>
              <div className="flex-containet justify-content--start">
                <span className="text-secondary">
                  This will appear in the invoice and reciept PDFs.
                </span>
              </div>
            </div>
          }
        /> */}

        <LeftRightSection
          hasBorder={true}
          leftText="Default due"
          rightText={
            <div className="flex-container gap-2 col justify-content--center align-items--start">
              <div className="flex-container dropdown-container justify-content--start align-items--center row">
                Payment due
                <div className="">
                  <select {...register("invoice_days_to_payment_due_default")}>
                    <option value={30}>30 days</option>
                    <option value={15}>15 days</option>
                    <option value={7}>7 days</option>
                    <option value={3}>3 days</option>
                    <option value={1}>1 day</option>
                    <option value={0}>immediately</option>
                  </select>
                </div>
                <div>after invoice is sent</div>
              </div>

              {/* <div className="flex-container col gap-2">
                <div>Payment methods and gateways</div>
                <div className="flex-container row gap-4 justify-content--between align-items--center">
                  <div className="flex-container row gap-1">
                    <img src={ussd} />
                    <img src={paystackLogo} />
                    <img src={flutterwaveLogo} />
                    <img src={stripeLogo} />
                    <img src={squareLogo} />
                    <img src={code} />
                    <img src={card} />
                    <img src={bank} />
                  </div>
                  <div className="edit-invoice">
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"></path>
                      <path
                        fill-rule="evenodd"
                        d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    edit
                  </div>
                </div>
              </div> */}
            </div>
          }
        />

        <div className="flex-container invoice-bottom justify-content--end align-items--center">
          <div className="button-group">
            <SwitchAppButton size="sm" kind="secondary" onClick={goBack}>
              Cancel
            </SwitchAppButton>
            <SubmitButton
              size="sm"
              // disabled={!isDirty}
              showChildrenWithLoadingIcon
            >
              Save
            </SubmitButton>
          </div>
        </div>
      </SectionedHorizontalLinedTable>
    </form>
  );
};
